<template>
  <v-app-bar elevation="0" class="bg-white border-b navbar-responsive" style="border-color: rgba(0,0,0,0.05) !important;" id="navbarcentral">
    <v-container fluid class="d-flex align-center navbar-container h-100">
      <!-- Logo Principal - Espacio limpio -->
      <div class="d-flex align-center py-2 logo-container">
      <router-link :to="{ name: 'tickets' }" class="d-block transition-swing hover-scale" style="display: inline-block;">
        <v-img :src="require('@/assets/logo-image-mkt.svg')" class="navbar-logo" contain></v-img>
      </router-link>
      </div>

      <v-spacer></v-spacer>

      <!-- Zona Derecha: Moderna y Aireada -->
      <div class="d-flex align-center gap-4 navbar-actions">
        
        <!-- Logo Secundario (Marca de agua sutil) - Oculto en móvil -->
        <div class="d-none d-md-flex align-center mr-6 opacity-60 grayscale hover-grayscale-off transition-all">
          <v-img :src="require('@/assets/logo-tic.svg')" width="50" contain></v-img>
        </div>

        <!-- Menu Usuario - Diseño "Píldora" Moderno -->
        <v-menu v-model="menu" :close-on-content-click="false" location="bottom end" transition="slide-y-transition" offset="16">
          <template v-slot:activator="{ props }">
            <div v-bind="props" class="d-flex align-center cursor-pointer user-pill-wrapper rounded-pill transition-all user-pill" :class="{'bg-grey-lighten-5': menu}">
              
              <!-- Info de Usuario - Oculta en móvil -->
              <div class="d-none d-lg-flex flex-column align-end mr-3">
                <span class="text-subtitle-2 font-weight-black text-grey-darken-4 line-height-1">
                  {{ capitalizeWords(oneName(user.nombres) + ' ' + oneName(user.apellidos)) }}
                </span>
                <span class="text-caption text-primary font-weight-bold text-uppercase mt-1" style="font-size: 0.65rem; letter-spacing: 1px;">
                  {{ user.role_user.name }}
                </span>
              </div>

              <!-- Avatar con Anillo Gradiente -->
              <div class="avatar-ring rounded-circle">
                <v-avatar class="user-avatar border-2 border-white" image>
                  <v-img v-if="user.avatar" :src="user.avatar" cover></v-img>
                  <span v-else class="text-subtitle-1 font-weight-bold text-white bg-grey-darken-4 w-100 h-100 d-flex align-center justify-center">
                    {{ initialName(user.nombres + ' ' + user.apellidos) }}
                  </span>
                </v-avatar>
              </div>
              
              <!-- Icono Chevron Minimalista - Oculto en móvil pequeño -->
              <v-icon size="small" class="chevron-icon" :class="{'rotate-180': menu}">
                fa:fa-solid fa-chevron-down
              </v-icon>
            </div>
          </template>

          <!-- Dropdown Menu - Estilo Popover Moderno -->
          <v-card width="280" class="rounded-xl shadow-soft mt-2 border-0 overflow-visible" elevation="10">
            <!-- Triángulo decorativo CSS (opcional, simula popover nativo) -->
            
            <div class="pa-6 text-center">
               <v-avatar size="72" class="mb-3 elevation-5 shadow-colored">
                  <v-img v-if="user.avatar" :src="user.avatar" cover></v-img>
                  <span v-else class="text-h4 font-weight-bold text-white bg-gradient-primary w-100 h-100 d-flex align-center justify-center">
                    {{ initialName(user.nombres + ' ' + user.apellidos) }}
                  </span>
               </v-avatar>
               
               <h3 class="text-h6 font-weight-black text-grey-darken-4 mb-0">
                  {{ capitalizeWords(oneName(user.nombres)) }}
               </h3>
               <p class="text-caption text-grey-darken-1 mb-4">{{ user.email }}</p>
               
               <v-btn block rounded="pill" variant="tonal" color="primary" class="font-weight-bold text-capitalize" :to="{ name: 'profileUser' }">
                  Editar Perfil
               </v-btn>
            </div>

            <v-divider class="border-opacity-5"></v-divider>

            <div class="pa-2">
               <v-list density="compact" nav class="pa-0">
                  <v-list-item @click="logout()" rounded="lg" class="text-red-accent-3 py-2 px-4 hover-red">
                     <template v-slot:prepend>
                        <v-icon icon="fa:fa-solid fa-arrow-right-from-bracket" size="small" class="mr-3"></v-icon>
                     </template>
                     <v-list-item-title class="font-weight-bold text-body-2">Cerrar Sesión</v-list-item-title>
                  </v-list-item>
               </v-list>
            </div>
          </v-card>
        </v-menu>
      </div>
    </v-container>
  </v-app-bar>
</template>

<style scoped>
/* Responsive Navbar */
.navbar-responsive {
  height: 64px;
}

.navbar-container {
  padding-left: 2rem;
  padding-right: 2rem;
}

.navbar-logo {
  width: 220px;
  max-width: 220px;
}

.user-avatar {
  size: 42px;
}

.user-pill-wrapper {
  padding: 4px 4px 4px 8px;
}

.chevron-icon {
  font-size: 12px;
  margin-left: 4px;
}

/* Media Queries para Móvil */
@media (max-width: 960px) {
  .navbar-responsive {
    height: 60px;
  }
  
  .navbar-container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  
  .navbar-logo {
    width: 160px;
    max-width: 160px;
  }
  
  .gap-4 {
    gap: 0.5rem;
  }
}

@media (max-width: 600px) {
  .navbar-responsive {
    height: 56px;
  }
  
  .navbar-container {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  
  .navbar-logo {
    width: 130px;
    max-width: 130px;
  }
  
  .logo-container {
    padding: 0.25rem 0;
  }
  
  .user-avatar {
    size: 36px;
  }
  
  .user-pill-wrapper {
    padding: 3px;
  }
  
  .chevron-icon {
    display: none;
  }
  
  .gap-4 {
    gap: 0.25rem;
  }
  
  .navbar-actions {
    flex-shrink: 0;
  }
}

/* Estilos Base */
.gap-4 { gap: 1rem; }
.hover-scale:hover { transform: scale(1.02); }
.grayscale { filter: grayscale(100%); opacity: 0.6; }
.hover-grayscale-off:hover { filter: grayscale(0%); opacity: 1; }
.user-pill:hover { background-color: #f8f9fa; }
.rotate-180 { transform: rotate(180deg); }

/* Gradiente de Marketing */
.avatar-ring {
  background: linear-gradient(135deg, #6366F1 0%, #EC4899 100%);
  padding: 2px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #002B49 0%, #005691 100%);
}

.shadow-soft {
  box-shadow: 0 20px 40px -10px rgba(0,0,0,0.15) !important;
}

.shadow-colored {
  box-shadow: 0 10px 25px -5px rgba(99, 102, 241, 0.4) !important;
}

.hover-red:hover {
  background-color: #FEF2F2 !important;
}
</style>

<script>
import Filters from '@/modules/Shared/Filters';
import { mapState, mapActions } from 'vuex';
export default {
  mixins: [
    Filters
  ],
  data() {
    return {
      menu: false
    }
  },

  computed:
  {
    ...mapState(['user'])
  },

  methods: {
    ...mapActions('login', ['logout'])
  }
}
</script>